
import { Tool } from '../view';

export const SelectBrushTool = Tool.extend({

  type: 'Select',

  toolbarName: 'selectBrush',
  allowKeyShortcuts: true,

  initTool( view, config ) {
    const th = ['Click to select a brush'];
    this.toolhelp(th);
  },

  on_pointerdown({ view, event, which, cmdKey, docPoint, pointers }) {
    const leftClick = which === 1;
    if( ! leftClick ) {
      return ;
    }
    view.fireEvent('brushselected',view.getBrushAtPoint(docPoint));
    event.stopPropagation();

  },

  on_pointerup( event ) {
  }

});

Tool.SelectBrush = SelectBrushTool;



/** WEBPACK FOOTER **
 ** ./src/ui/tool/select-brush.js
 **/